import React, { useState, useEffect } from 'react';

import { iZettleProfile } from '../../models/Profile';

import './Setup.billLink.scss';

import Modal from 'react-modal';
import { useMutation } from '@apollo/client';
import { graphqlSchema } from '../../services/graphql.schema';
import GraphQlClient from '../../services/graphql';
import sharedToasterSubject from '../../services/shared.toasterSubject';
import Input from '../Forms/Input';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import IconButton from '../Forms/IconButton';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        border: 'none',
        boxShadow: '3px 4px 15px rgba(170, 170, 208, 0.5)',
        transform: 'translate(-50%, -50%)',
        overflow: 'visible'
    }
};
Modal.setAppElement('#root');

function SetupBillingLink({ izettleProfile }: { izettleProfile: iZettleProfile }) {

    const [checkingUrlIsLoading, setCheckingUrlIsLoading] = useState(false);
    const [showMailExample, setShowMailEx] = useState(false);

    const [billUrlOk, setBillUrlOk] = useState(true);
    const [billUrl, setBillUrl] = useState(izettleProfile.billingUrl)
    const [billUrlSubject] = useState(new Subject<string>());

    const [setBillingUrl] = useMutation(graphqlSchema.PROFILE.SETUP.setSelfBillingUrl, {
        onCompleted: ({ setSelfBillingUrl }: { setSelfBillingUrl: { billingUrl: string } }) => {
            console.log('Updated Link: ', setSelfBillingUrl);
            GraphQlClient.modifyClientMLprofile(setSelfBillingUrl);
            sharedToasterSubject.next({ type: 'confirm', message: `Se actualizó su link de facturación a https://zettle.fiscalpop.com/facturas/${setSelfBillingUrl.billingUrl}` });
        },
        onError: (e) => {
            console.error(e)
            sharedToasterSubject.next({ type: 'error', message: e.message });
        }
    })
    const [checkBillingUrl] = useMutation(graphqlSchema.PROFILE.SETUP.checkSelfBillingUrl, {
        onCompleted: ({ checkSelfBillingUrl }: { checkSelfBillingUrl: boolean }) => {
            console.log('checkSelfBillingUrl: ', checkSelfBillingUrl);
            setCheckingUrlIsLoading(false);
            setBillUrlOk(checkSelfBillingUrl)
            // sharedToasterSubject.next({ type: 'confirm', message: `Actualizó su preferencia de link de autofacturación` });
        },
        onError: (e) => {
            setCheckingUrlIsLoading(false);
            setBillUrlOk(false);
            sharedToasterSubject.next({ type: 'error', message: e.message });
        }
    })

    useEffect(() => {
        const subs = billUrlSubject.pipe(debounceTime(450)).subscribe((url => {
            checkBillingUrl({
                variables: {
                    billingUrl: url
                }
            })
        }))
        return () => { subs.unsubscribe() }
    }, [billUrlSubject, checkBillingUrl])


    const enableBillLink = () => {
        console.log('PROF', JSON.parse(JSON.stringify({
            variables: {
                billingUrl: billUrl
            }
        })));
        setBillingUrl({
            variables: {
                billingUrl: billUrl
            }
        })
    }

    const closeExamples = () => {
        setShowMailEx(false);
    }

    const openMailEx = () => {
        setShowMailEx(true);
    }

    const _setBillUrl = (str: string) => {
        str = str.toLowerCase().split('').filter(s => /^\w+$/.test(s)).join('')
        if(str !== billUrl){
            setBillUrl(str)
            setCheckingUrlIsLoading(true);
            billUrlSubject.next(str)
        }
    }

    const renderCheck = () => {
        if (checkingUrlIsLoading) {
            return (
                <span className="material-icons circle">
                    autorenew
                </span>
            )
        }
        if (!billUrlOk) {
            return (
                <span className="material-icons red">
                    close
                </span>
            )
        } else {
            return (
                <span className="material-icons green">
                    done
                </span>
            )
        }
    }

    return (
        <div className="card" id="SetupBillLink">
            <div className="title">
                <h4>Enviar link de autofacturación a tu cliente</h4>
                <IconButton primary={true} disabled={!billUrlOk || (izettleProfile.billingUrl === billUrl)} handleClick={enableBillLink}>
                    <i className="material-icons">
                        save
                    </i>
                </IconButton>
            </div>
            <div className="enableEmbedded">
                <p>
                    Permite que tus clientes facturen en linea agregando el link de facturación en linea en tu ticket impreso y digital. <br />
                </p>
                <div className="entries">
                    <p>
                        https://zettle.fiscalpop.com/facturas/
                    </p>
                    <Input type="text" label="Tu URL de facturación" placeholder="" value={billUrl} onChange={_setBillUrl} onBlur={enableBillLink}/>
                    {renderCheck()}
                </div>
                <p>
                    Agrega la dirección <b>https://zettle.fiscalpop.com/facturas/{izettleProfile.billingUrl}</b> en tu ticket de Zettle en la sección de "Mas Información".
                </p>
                <div className="example">
                    <p>
                        <b className="_example" onClick={openMailEx}>Ver ejemplo de ticket con URL de facturación</b>
                    </p>
                </div>
            </div>
            <Modal
                isOpen={showMailExample}
                onRequestClose={closeExamples}
                style={customStyles}
                shouldCloseOnEsc={true}
                shouldCloseOnOverlayClick={true}
                contentLabel="FiscalPOP Modal"
            >
                <div id="_FiscalpopDialog">
                    <h4>
                        Ejemplo de "Agregar correo"
                    </h4>
                </div>
                <div>
                    <img alt="Ejemplo de guardar correo" src="https://fiscalpop.sfo2.cdn.digitaloceanspaces.com/assets/zettle_bill_url.png" className="imEx" />
                </div>
            </Modal>
        </div>
    )
}

export default SetupBillingLink;
